import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { trackRouteChange } from '../services/eventTracking';

const RouteTracker = () => {
  const history = useHistory();
  const previousPath = useRef(null);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      const fromUrl = previousPath.current || '';
      const toUrl = location.pathname;

      // Track route change using eventTracking service
      if (fromUrl !== toUrl) {
        trackRouteChange(fromUrl, toUrl);
      }

      // Update tracking
      previousPath.current = toUrl;
    });

    // Set initial path
    if (!previousPath.current) {
      previousPath.current = window.location.pathname;
    }

    return () => unlisten();
  }, [history]);

  return null;
};

export default RouteTracker;
